import { mixed, object, string } from 'yup';
import * as Yup from 'yup';

import { AUSTRALIAN_STATES, AustralianState } from 'src/constants';
import { SnakeCaseKeysToCamelCase } from 'src/utils/convertCase';

import {
  TradeInSearchCarRegoSchemaFields,
  TradeInSearchCarVINSchemaFields,
} from './TradeInSearchCar/TradeInSearchCar.schema';

const errorRego = 'Please enter a valid registration plate';
const errorState = 'Please select a state';

export type Source = 'trade-in-pdp' | 'trade-in-enquiry';

export type TradeInSearchData = TradeInSearchCarRegoSchemaFields | TradeInSearchCarVINSchemaFields;
const checkRegoLength: Yup.TestFunction = (value: string | undefined) => {
  return !!value && value.replaceAll(' ', '').length <= 7;
};

export const RegoValidation = object({
  rego: string().required(errorRego).test('character-length', errorRego, checkRegoLength),
  state: mixed().oneOf(AUSTRALIAN_STATES, errorState).required(errorState),
});

/**
 * Convert types of values of an object to string or string[].
 * If a property's type extends string the original type is retained
 */
export type StringifyValues<T extends {}> = {
  [K in keyof T]: NonNullable<T[K]> extends string | string[] | object ? T[K] : string;
};

export interface TradeInSearchResult {
  cylinders: string;
  description: string;
  // these params from the API are in camelcase
  /* eslint-disable camelcase */
  engine_size: number;
  fuel_type: string;
  make_name: string;
  model_name: string;
  model_year: number;
  /* eslint-enable camelcase */
  rego: string;
  state: AustralianState;
  transmission: string;
  variant: string;
  vin: string;
}

export interface TradeInCT {
  image_car_front_url: string;
  image_car_back_url: string;
  image_car_left_url: string;
  image_car_right_url: string;
  optional_extra_image_urls: string;
  interior_condition_image_urls: string;
  exterior_condition_image_urls: string;
}

export type TradeInSearchResultStrings = StringifyValues<TradeInSearchResult>;
export type CamelCaseTradeInSearchResult = SnakeCaseKeysToCamelCase<TradeInSearchResult>;
export type CamelCaseTradeInSearchResultStrings = StringifyValues<CamelCaseTradeInSearchResult>;
export type CamelCaseTradeInCT = SnakeCaseKeysToCamelCase<TradeInCT>;

export type MakeModelResponseData = {
  type: 'make';
  label: string;
  children: {
    type: 'model';
    label: string;
    children: {
      type: 'variant';
      label: string;
    }[];
  }[];
}[];

export type MakeModelData = Record<string, Record<string, string[]>>;
